// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"224bdfc8","787":"4444550c"}[chunkId] + ".chunk.js";
};